<template>
    <div class="page-cabinet-verification-profile" data-step="personal-data">
        <transition name="fade">
            <div class="page-cabinet-verification-profile__loader"
                v-if="isLoading"
                >
                <div class="page-cabinet-verification-profile__loader-container">
                    <ui-loader />
                </div>
            </div>
        </transition>
        <template v-if="!isLoading">
            <common-collapsible title="Ваши данные в безопасности" bordered>
                <div class="page-cabinet-verification-profile__notice-content">
                    Мы запрашиваем ваши данные для установления личности, идентификации и присвоения статуса Инвестора (п. 6 ст. 3 259-ФЗ*, п. 1 ст. 7 115-ФЗ**). После проведения проверки, вы сможете получить доступ к полному функционалу Платформы.<br/>
                    <ul>
                        <li><strong>Безопасность.</strong> Мы включены в реестр Банка России (№ 20 от 19.01.2021), таким образом, работаем в правовом поле и под надзором Регулятора.</li>
                        <li><strong>Конфиденциальность.</strong> Соблюдаем нормы, установленные ст. 7 152-ФЗ*** Все ваши данные защищены и конфиденциальны.</li>
                        <li><strong>Конкретные цели.</strong> Используем ваши данные исключительно в целях соблюдения действующего законодательство РФ для функционирования Платформы, в соответствии с нашей Политикой конфиденциальности.</li>
                    </ul>
                    <strong>Спасибо за доверие!</strong>
                </div>
                <div class="page-cabinet-verification-profile__notice-footer">
                    * Федеральный закон от 02.08.2019 N 259-ФЗ «О привлечении инвестиций с использованием инвестиционных платформ и о внесении изменений в отдельные законодательные акты Российской Федерации».<br/>
                    ** Федеральный закон от 07.08.2001 N 115-ФЗ «О противодействии легализации (отмыванию) доходов, полученных преступным путём, и финансированию терроризма».<br/>
                    *** Федеральный закон от 27.07.2006 N 152-ФЗ «О персональных данных».
                </div>
            </common-collapsible>

            <div class="page-cabinet-verification-profile__top">
                <div class="page-cabinet-verification-profile__top-title" v-if="subtitle">
                    {{ subtitle }}
                </div>
                <div v-else class="page-cabinet-verification-profile__top-padding" />
                <div>
                    <page-cabinet-verification-profile-general
                        v-bind:is-touched="isTouched"
                        v-on:validation-update="validationUpdate"
                        v-on:touch="isTouched = true"
                        v-on:submit="submit"
                    />
                </div>
                <template v-if="isJuridicalFormNeeded">
                    <div class="page-cabinet-verification-profile__top-title">
                        Данные организации
                    </div>
                    <div>
                        <page-cabinet-verification-profile-juridical
                            v-bind:is-touched="isTouched"
                            v-on:validation-update="validationUpdate"
                            v-on:touch="isTouched = true"
                            v-on:submit="submit"
                        />
                    </div>
                </template>
                <div class="page-cabinet-verification-profile__top-title">
                    Загрузите документы
                </div>
                <div>
                    <page-cabinet-verification-profile-photos
                        v-bind:is-touched="isTouched"
                        v-on:validation-update="validationUpdate"
                    />
                </div>
                <template v-if="isJuridicalFormNeeded">
                    <div style="margin-top: 24px">
                        <page-cabinet-verification-profile-other-docs
                            v-bind:is-touched="isTouched"
                            v-on:validation-update="validationUpdate"
                        />
                    </div>
                </template>
                <div style="margin-top: 24px">
                    <policy-consent-checkbox
                        v-model="privacyAccepted"
                        v-bind:show-error="privacyAcceptedError && !privacyAccepted"
                        variant="verification"
                    />
                </div>
                <div class="page-cabinet-verification-profile__error"
                     v-if="isPhoneExistError"
                >
                    Указанный номер телефона уже зарегистрирован
                </div>
                <div class="page-cabinet-verification-profile__error"
                     v-if="isEmailExistError"
                >
                    Указанный адрес электронной почты уже используется
                </div>
                <div class="page-cabinet-verification-profile__error"
                     v-if="isIdxSubmitFailed || isUpdateProfileUnknownError"
                >
                    Не удалось отправить документы. Попробуйте еще раз
                </div>
            </div>
        </template>
        <div class="page-cabinet-verification-profile__buttons">
            <div class="page-cabinet-verification-profile__buttons-item">
                <ui-button
                    v-bind:disabled="(!isValid && isTouched) || isLoading"
                    v-on:click="submit"
                    theme="primary"
                    type="button"
                    size="lg"
                    >
                    Отправить на проверку
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
// import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import utils from '~/utils';
import { IdxStatus } from '~/constants';
// import config from '~/config';
// import forms from '~/forms';

export default {
    name: 'page-cabinet-verification-profile',
    props: {
        isFilled: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        isTouched: false,
        isGeneralDataValid: true,
        isPhotosDataValid: true,
        // isForeignerDataValid: true,
        isIndividualDataValid: true,
        isIpDataValid: true,
        isJuridicalDataValid: true,
        isJuridicalDocsDataValid: true,
        isValid: true,
        privacyAccepted: false,
        privacyAcceptedError: false,
    }),
    computed: {
        // ...mapState('geo', [
        //     'getCountriesIsLoading',
        //     'getCountriesResult',
        // ]),
        ...mapGetters('verification', [
            'isIdxFlow',
        ]),
        ...mapState('users', [
            'user',

            'getUserProfileResult',
            'getUserProfileIsLoading',

            'getUserPersonalInfoResult',
            'getUserPersonalInfoIsLoading',

            'getUserPhotosResult',
            'getUserPhotosIsLoading',

            'getUserJuridicalInfoResult',
            'getUserJuridicalInfoIsLoading',
        ]),
        ...mapState('verification/idx', [
            'getIdxStateResult',
            'getIdxStateIsLoading',
            'getIdxStateError',

            'submitIdxError',
        ]),
        ...mapGetters('verification/idx', [
            'isIdxLimitExceeded',
        ]),
        ...mapGetters('users', [
            'isPhoneExistError',
            'isEmailExistError',
            'isUpdateProfileUnknownError',
        ]),
        // isForeignerFormNeeded() {
        //     return this.$store.state.verification.profile.general.citizenship &&
        //         this.$store.state.verification.profile.general.citizenship !== 'RU' &&
        //         this.$store.state.verification.profile.general.citizenship !== 'BY';
        // },
        isIndividualFormNeeded() {
            return this.getUserProfileResult?.legalType === 'F';
        },
        isIpFormNeeded() {
            return this.getUserProfileResult?.legalType === 'I';
        },
        isJuridicalFormNeeded() {
            return this.getUserProfileResult?.legalType === 'J';
        },
        isLoading() {
            return this.getUserProfileIsLoading ||
                this.getUserPersonalInfoIsLoading ||
                this.getUserJuridicalInfoIsLoading ||
                this.getIdxStateIsLoading;
        },
        profile() {
            return this.$store.state.verification.profile;
        },
        subtitle() {
            return this.isJuridicalFormNeeded
                ? 'Данные единоличного исполнительного органа организации'
                : '';
        },
        isIdxSubmitFailed() {
            return this.getIdxStateResult?.status === IdxStatus.FAILED || this.submitIdxError;
        },
    },
    methods: {
        validationUpdate({ entityName, value }) {
            this[entityName] = value;
            this.isValid = this.isGeneralDataValid &&
                this.isIndividualDataValid &&
                this.isIpDataValid &&
                this.isJuridicalDataValid &&
                this.isPhotosDataValid;
        },
        submit() {
            if (this.isLoading) {
                return;
            }
            this.$store.commit('verification/profile/trimName');
            if (!this.privacyAccepted) {
                this.privacyAcceptedError = true;
                return;
            }
            if (!this.isValid) {
                this.isTouched = true;
                return;
            }

            let requestsCounter = 0;
            const requestsCounterTarget = 3;
            const checkRequestsTarget = () => {
                if (requestsCounter === requestsCounterTarget) {
                    this.$emit('filled', 'profile');
                    this.$emit('submitted');
                }
            };

            // IDX flow
            if (this.isIdxFlow) {
                this.$store.dispatch('users/updateUserProfile', {
                    phone: this.profile.general.phone,
                    email: this.profile.general.email,
                    onSuccess: () => {
                        requestsCounter++;
                        requestsCounter++;
                        checkRequestsTarget();

                        this.$store.dispatch('verification/idx/submitIdxVerification', {
                            onSuccess: (data) => {
                                this.$store.dispatch('verification/idx/getIdxState');
                                if (
                                    (data?.status === IdxStatus.RETRY_REQUIRED && !this.isIdxLimitExceeded) ||
                                    data?.status === IdxStatus.FAILED
                                ) {
                                    return;
                                }
                                requestsCounter++;
                                checkRequestsTarget();
                            },
                        });
                    },
                });
            } else {
                // No IDX flow
                this.$store.dispatch('users/updateUserProfile', {
                    phone: this.profile.general.phone,
                    email: this.profile.general.email,
                    firstName: this.profile.general.firstName,
                    secondName: this.profile.general.secondName,
                    lastName: this.profile.general.lastName,
                    onSuccess: () => {
                        requestsCounter++;
                        requestsCounter++; // TODO del
                        checkRequestsTarget();
                    },
                });
                this.$store.dispatch('users/updateUserPersonalInfo', {
                    passportSeries: this.profile.general.passportSeries,
                    passportNumber: this.profile.general.passportNumber,
                    onSuccess: () => {
                        requestsCounter++;
                        checkRequestsTarget();
                    },
                });

                const juridicalInfoPayload = {
                    organizationName: null,
                    organizationAddress: null,
                    legalAddress: null,
                    mailingAddress: null,
                    bankName: null,
                    ogrn: null,
                    okved: null,
                    inn: this.profile.general.inn,
                    kpp: null,
                    bik: null,
                    bankAccount: null,
                    cadastralAccount: null,
                    dateRegistration: null,
                    snils: null,
                };
                if (this.getUserProfileResult.legalType === 'F' || this.getUserProfileResult.legalType === 'I') {
                    juridicalInfoPayload.snils = this.profile.general.snils;
                }
                if (this.getUserProfileResult.legalType === 'F' && this.profile.individual.hasIp) {
                    juridicalInfoPayload.ogrn = this.profile.ip.ogrnip;
                } else if (this.getUserProfileResult.legalType === 'I') {
                    juridicalInfoPayload.organizationName = this.profile.ip.ipName;
                    juridicalInfoPayload.organizationAddress = this.profile.ip.ipAddress;
                    juridicalInfoPayload.legalAddress = this.profile.ip.ipAddress;
                    juridicalInfoPayload.mailingAddress = this.profile.ip.ipAddress;
                    juridicalInfoPayload.ogrn = this.profile.ip.ogrnip;
                } else if (this.getUserProfileResult.legalType === 'J') {
                    juridicalInfoPayload.organizationName = this.profile.juridical.organizationName;
                    // juridicalInfoPayload.organizationNameFull = this.profile.juridical.organizationNameFull;
                    juridicalInfoPayload.organizationAddress = this.profile.juridical.organizationAddress;
                    juridicalInfoPayload.legalAddress = this.profile.juridical.organizationRegistrationAddress;
                    juridicalInfoPayload.mailingAddress = this.profile.juridical.organizationPostalAddress;
                    // juridicalInfoPayload.bankName = this.profile.juridical.bankName;
                    juridicalInfoPayload.ogrn = this.profile.juridical.ogrn;
                    // juridicalInfoPayload.okved = this.profile.juridical.okved;
                    juridicalInfoPayload.kpp = this.profile.juridical.kpp;
                    // juridicalInfoPayload.bik = this.profile.juridical.bik;
                    // juridicalInfoPayload.corrAccount = this.profile.juridical.corrAccount;
                    // juridicalInfoPayload.dateRegistration = this.profile.juridical.organisationRegistrationDate;
                }
                this.$store.dispatch('users/updateUserJuridicalInfo', {
                    ...juridicalInfoPayload,
                    onSuccess: () => {
                        requestsCounter++;
                        checkRequestsTarget();
                    },
                });
            }
        },
    },
    beforeMount() {
        this.$store.dispatch('users/getUserPhotos', {
            userId: this.user.id,
        });
        this.$store.dispatch('users/getUserProfile');
        this.$store.dispatch('users/getUserPersonalInfo');
        this.$store.dispatch('users/getUserJuridicalInfo');
        this.$store.dispatch('verification/idx/getIdxState');
        utils.analytics.ym.personalDataStep();
    },
    watch: {
        getUserProfileResult: {
            handler(newVal, oldVal) {
                if (newVal && !oldVal) {
                    const result = {};
                    if (newVal.firstName) {
                        result.firstName = newVal.firstName;
                    }
                    if (newVal.lastName) {
                        result.lastName = newVal.lastName;
                    }
                    if (newVal.secondName) {
                        result.secondName = newVal.secondName;
                    }
                    if (newVal.phone) {
                        result.phone = newVal.phone;
                    }
                    if (newVal.email) {
                        result.email = newVal.email;
                    }
                    this.$store.state.verification.profile.general = {
                        ...this.$store.state.verification.profile.general,
                        ...result,
                    };
                }
            },
            immediate: true,
        },
        getUserJuridicalInfoResult: {
            handler(newVal, oldVal) {
                if (newVal && !oldVal) {
                    const resultGeneral = {};
                    const resultIp = {};
                    const resultJuridical = {};
                    if (newVal.inn) {
                        resultGeneral.inn = newVal.inn;
                    }
                    if (newVal.snils) {
                        resultGeneral.snils = newVal.snils;
                    }
                    if (newVal.ogrn) {
                        resultIp.ogrnip = newVal.ogrn;
                        resultJuridical.ogrn = newVal.ogrn;
                    }
                    if (newVal.organizationName) {
                        resultIp.ipName = newVal.organizationName;
                        resultJuridical.organizationName = newVal.organizationName;
                    }
                    if (newVal.organizationNameFull) {
                        resultJuridical.organizationNameFull = newVal.organizationNameFull;
                    }
                    if (newVal.organizationAddress) {
                        resultIp.ipAddress = newVal.organizationAddress;
                        resultJuridical.organizationAddress = newVal.organizationAddress;
                    }
                    if (newVal.legalAddress) {
                        resultJuridical.organizationRegistrationAddress = newVal.legalAddress;
                    }
                    if (newVal.mailingAddress) {
                        resultJuridical.organizationPostalAddress = newVal.mailingAddress;
                    }
                    if (newVal.okved) {
                        resultJuridical.okved = newVal.okved;
                    }
                    if (newVal.kpp) {
                        resultJuridical.kpp = newVal.kpp;
                    }
                    if (newVal.bik) {
                        resultJuridical.bik = newVal.bik;
                    }
                    if (newVal.bankName) {
                        resultJuridical.bankName = newVal.bankName;
                    }
                    if (newVal.corrAccount) {
                        resultJuridical.corrAccount = newVal.corrAccount;
                    }
                    if (newVal.dateRegistration) {
                        resultJuridical.organisationRegistrationDate = newVal.dateRegistration;
                    }
                    this.$store.state.verification.profile.general = {
                        ...this.$store.state.verification.profile.general,
                        ...resultGeneral,
                    };
                    this.$store.state.verification.profile.ip = {
                        ...this.$store.state.verification.profile.ip,
                        ...resultIp,
                    };
                    this.$store.state.verification.profile.juridical = {
                        ...this.$store.state.verification.profile.juridical,
                        ...resultJuridical,
                    };
                }
            },
            immediate: true,
        },
        getUserPersonalInfoResult: {
            handler(newVal, oldVal) {
                if (newVal && !oldVal) {
                    const resultGeneral = {};
                    if (newVal.passportNumber) {
                        resultGeneral.passportNumber = newVal.passportNumber;
                    }
                    if (newVal.passportSeries) {
                        resultGeneral.passportSeries = newVal.passportSeries;
                    }
                    this.$store.state.verification.profile.general = {
                        ...this.$store.state.verification.profile.general,
                        ...resultGeneral,
                    };
                }
            },
            immediate: true,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-verification-profile {
    position: relative;
    &__loader {
        .transition-fade();

        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;

        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        background-color: fade(@color-gray-lightest, 50%);
        &-container {
            width: 100px;
            margin: auto;
        }
    }
    &__notice {
        &-content {
            .typography-body();
        }
        &-footer {
            .typography-caption();

            padding-top: 6px;
            margin: 6px 0 16px 0;
            color: @color-gray-darker;
            border-top: 1px solid @color-gray-light;
        }
    }
    &__top {
        width: 100%;
        margin-bottom: 40px;
        &-title {
            .typography-heading();

            margin-top: 24px;
            margin-bottom: 24px;
        }
        &-padding {
            height: 32px;
        }
    }
    &__buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        &-item {
            width: 100%;
            max-width: 290px;
            padding: 12px;
        }
    }
    &__error {
        .typography-body();

        margin-top: 24px;

        color: @color-accent-negative;
        text-align: center;
    }
    @media @media-md-down {
        &__top {
            flex-direction: column;

            &-padding {
                height: 24px;
            }
        }
    }
}
</style>
